// /products/web/src/utils/correlation-id.ts
/**
 * Session-scoped ADR-03 CorrelationID, shared by ClientLogsService and
 * callApi so a browser session's client logs and internal API calls can be
 * joined by the same id. Kept dependency-free to avoid a circular import
 * between client-logs.service.ts and api-client.ts.
 */

let correlationId: string | undefined;

const generateCorrelationId = (): string => {
  if (typeof globalThis.crypto?.randomUUID === "function") {
    return globalThis.crypto.randomUUID();
  }
  if (typeof globalThis.crypto?.getRandomValues === "function") {
    const randomBytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
    return `corr-${Array.from(randomBytes)
      .map((byte) => byte.toString(16).padStart(2, "0"))
      .join("")}`;
  }
  throw new Error("Web Crypto API is required to generate a correlation ID");
};

/**
 * Returns the active correlation id, minting one on first use.
 */
export const getCorrelationId = (): string => {
  if (!correlationId) {
    correlationId = generateCorrelationId();
  }
  return correlationId;
};
